module.exports = __webpack_public_path__ + "img/day-pass--1x.24c0ad78.jpg";